import React, { useMemo } from "react";
import { Card } from "./card";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { useGameResponsive } from "@/hooks/use-game-responsive";

interface OpponentHandProps {
  numCards: number;
  playerId: number | undefined;
  className?: string;
  noAnimation?: boolean;
  isOpponentState?: boolean;
}

export function OpponentHand({
  numCards = 5,
  playerId,
  className,
  noAnimation = true,
  isOpponentState = true
}: Readonly<OpponentHandProps>) {
  // Use our game-specific responsive hook to match PlayerHand sizing
  const { getCardSize, getSpacing } = useGameResponsive();
  
  // Get spacing based on screen size
  const spacing = getSpacing();
  
  // Generate stable keys for the cards
  const cardKeys = useMemo(() => 
    Array.from({ length: numCards }).map(() => crypto.randomUUID()),
    [numCards]
  );

  return (
    <motion.div
      className={cn(
        "relative flex justify-center transition-all duration-300 w-full",
        className
      )}
    >
      <motion.div
        className={cn("flex justify-center gap-1 sm:gap-2 md:gap-3")}
      >
        {cardKeys.map((key) => (
          <motion.div
            key={`player-${playerId}-${key}`}
            className="relative"
          >
            <div className="group relative transition-all duration-300">
              <Card
                value="back"
                className={cn(
                  // Use same sizing system as PlayerHand for consistency
                  (() => {
                    const cardSize = getCardSize();
                    return `w-[${cardSize.width}px] h-[${cardSize.height}px]`;
                  })(),
                  "transition-all opacity-90 shadow-md"
                )}
                noAnimation={noAnimation}
                isOpponent={true}
                opponentId={playerId}
                disabled={true}
              />
            </div>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
}